import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-edit-plan-start-date",
  templateUrl: "./edit-plan-start-date.component.html",
  styleUrls: ["./edit-plan-start-date.component.scss"],
})
export class EditPlanStartDateComponent {
  form = {
    activeDate: "2026-02-15",
    newExpirationDate: "2026-02-17",
  };

  // duration in days between active and expiration (comes from subscription data)
  private durationDays = 2;

  constructor(private dialogRef: MatDialogRef<EditPlanStartDateComponent>) {}

  calcExpiration(): void {
    if (!this.form.activeDate) return;
    const start = new Date(this.form.activeDate);
    start.setDate(start.getDate() + this.durationDays);
    this.form.newExpirationDate = start.toISOString().split("T")[0];
  }

  submit(): void {
    this.dialogRef.close(this.form);
  }

  close(): void {
    this.dialogRef.close();
  }
}
